$shm_hitalama_vk_analysis_summary $shm_hitalama_table
	token_str \
	owner_ids /string
	groups_dtos? null
	posts_dto_by_owner* null $shm_hitalama_vk_posts_dto
	head /
		<= Head_photo $mol_view sub / \
		<= Head_name $mol_view sub / \Название
		<= Head_members_count $mol_view sub / \Подписчики
		<= Head_posts_counts $mol_view sub / \Посты
		<= Head_views $mol_view sub / \Просмотры
		<= Head_likes $mol_view sub / \Лайки
		<= Head_reposts $mol_view sub / \Репосты
		<= Head_comments $mol_view sub / \Комментарии
		<= Head_ERv $mol_view sub / \ER.v, %
	Row* $mol_view
		sub /
			<= Photo* $mol_image 
				uri <= photo* \
				title <= owner_id* \
			<= Name* $mol_paragraph title <= name* \
			<= Member_counts* $mol_paragraph title <= members_count* \
			<= Posts_counts* $mol_paragraph title <= posts_counts* \
			<= Views* $mol_paragraph title <= views* \
			<= Likes* $mol_paragraph title <= likes* \
			<= Reposts* $mol_paragraph title <= reposts* \
			<= Comments* $mol_paragraph title <= comments* \
			<= ERv* $mol_paragraph title <= erv* \
	Sum_row $mol_view
		sub /
			<= Sum_photo $mol_paragraph title <= sum_photo \
			<= Sum_name $mol_paragraph title <= sum_name \Итого
			<= Sum_members_count $mol_paragraph title <= sum_members_count \
			<= Sum_posts_counts $mol_paragraph title <= sum_posts_counts \
			<= Sum_views $mol_paragraph title <= sum_views \
			<= Sum_likes $mol_paragraph title <= sum_likes \
			<= Sum_reposts $mol_paragraph title <= sum_reposts \
			<= Sum_comments $mol_paragraph title <= sum_comments \
			<= Sum_ERv $mol_paragraph title \
